import React, {Component} from 'react';
import Helmet from 'react-helmet';
import Award from 'react-feather/dist/icons/award.js';
import Box from 'react-feather/dist/icons/box.js';
import Calendar from 'react-feather/dist/icons/calendar.js';
import Clock from 'react-feather/dist/icons/clock.js';
import MapPin from 'react-feather/dist/icons/map-pin.js';
import DollarSign from 'react-feather/dist/icons/dollar-sign.js';
import Skills from "../../../../components/Skills/Skills.jsx";

import '../OfferDetails/OfferDetails.scss';

export default class OfferLoading extends Component {
  render() {
    return (
      <div className="container offer-container">
        <div className="row">
          <div className="mx-auto col bg-white bd-gray-200">
            <div className="offer-details loading">
              <Helmet>
                <title>Annonces</title>
              </Helmet>
              <div className="row intro">
                <div className="col-xxl-12 title">
                  <p />
                </div>
                <div className="col-xxl-12 details">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="item">
                        <MapPin/> &nbsp; Non précisé<br />
                      </div>
                      <div className="item">
                        <Award/> &nbsp; Non précisé<br />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="item">
                        <Calendar/> &nbsp; Non précisé<br />
                      </div>
                      <div className="item">
                        <Clock/> &nbsp; Non précisé<br />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="item">
                        <DollarSign /> &nbsp; Non précisé<br />
                      </div>
                      <div className="item">
                        <Box/> &nbsp; Non précisé<br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row bg-gray-100 actions">
                <div className="col-xxl-12 d-flex">
                  <Skills
                    key="offer-loading"
                    linkName="offers.search"
                    list={[{name: '...'}]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}